import React from "react";
import styles from "./style.module.css";
import { Grid } from "@mui/material";
import NotFound from "../../assets/imgs/404.jpg";
import { Empty, Image, Tag } from "antd";
function NewCardComp({ data }) {
  const dateFormetter = (timestamp) => {
    if (!timestamp) {
      return "No Date Found";
    }
    const dateObject = new Date(timestamp);
    const options = {
      month: "short",
      day: "2-digit",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    };
    return new Intl.DateTimeFormat("en-US", options).format(dateObject);
  };

  if (data.length === 0) {
    return (
      <div
        style={{
          fontSize: "18px",
          fontWeight: "600",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Empty />
      </div>
    );
  }
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        flexWrap: "nowrap",
        overflow: "auto",
        width:"78vw"
      }}
    >
      {data?.map((item, i) => (
        <div
          className={styles.card}
          style={{ marginLeft: "2rem", minWidth: "400px" }}
        >
          <div className={`${styles.ImgBox}`}>
            <Image
              width={370}
              alt="not found"
              src={item?.url ? item?.url : NotFound}
            />
          </div>
          <div className={styles.eventContent}>
            <p style={{ fontSize: "14px", fontWeight: "600" }}>
              <span className={styles.tagsName}>
                Violation:{" "}
                {item?.name ? (
                  <Tag color="processing">{item.name}</Tag>
                ) : (
                  "No Name"
                )}
              </span>

              <span className={styles.tagsName}>
                Time: <Tag color="success">{item?.time}</Tag>
              </span>
            </p>
          </div>
        </div>
      ))}
    </div>
  );
}

export default NewCardComp;
